export default{
  cancelOrderMap: {
    "0": "Tôi không muốn nó.",
        "1": "Sản phẩm bị đặt sai vị trí",
        "2": "Đơn hàng trùng lặp",
        "3": "Nhận không thành công",
        "4": "Lý do khác",
  },
  order: {
    cancel: "Hủy đơn hàng",
    payment: "Thanh toán ngay",
    confirm: "Xác nhận",
    remind: "Nhắc nhở lô hàng",
    return: "Yêu cầu hoàn tiền sản phẩm",
    evaluate: "Xem lại ngay bây giờ",
    logistics: "Xem hậu cần",
    noRefund: "Không được hoàn tiền",
    refunding: "Đang hoàn tiền",
    refundSuccess: "Hoàn tiền thành công",
    refundFail: "Hoàn tiền không thành công",
    remindTitle: "Nhắc nhở lô hàng",
  },
        
        "暂无数据": "Không có dữ liệu",
        "加载中": "Đang tải",
        "获取验证码": "Nhập mã xác nhận",
        "请输入验证码": "Vui lòng nhập mã xác nhận",
        "验证码": "Mã xác nhận",
        "发送": "Gửi",
        "已发送，请注意查收":
            "Đã gửi, vui lòng kiểm tra email của bạn",
        "电商批发商场": "Trung tâm bán buôn",
        "热销推荐": "Ưu đãi lớn",
        "用户未发表评论": "Người dùng chưa bình luận",
        "请输入关键字搜索": "Vui lòng nhập từ khóa để tìm kiếm",
        "请输入完整的支付密码!": "Vui lòng nhập đầy đủ mật khẩu thanh toán!",
        "subOrder": "Nộp",
        "KEY": "英语(en)",
        "-连接已建立-": "-Kết nối thành lập-",
        ",才可提币": ", và sau đó tiền mặt có thể được rút.",
        "[code]值错误": "giá trị [mã] không chính xác",
        "[symbol]参数为空": "Tham số [ký hiệu] trống",
        "goodsFreightTips1": "1. Công thức tính cước vận chuyển hàng hóa: Giá cước = Phí gửi hàng + Khoảng cách + Phí giao hàng",
        "creditQuotaINFO": "100.000 đến 30.000.000 với hạn mức linh hoạt và không hạn chế, thời hạn vay tối đa một năm.",
        "authentic": "100% nguyên bản",
        "homeIconTips1": "100% nguyên bản",
        "goodsFreightTips2": "2. Nếu không đáp ứng được các điều kiện về bưu chính thì phí vận chuyển sẽ được tính theo tình hình thực tế.",
        "goodsFreightTips3": "3. Quyền giải thích cuối cùng thuộc về Nền tảng.",
        "dayReturns7": "7 ngày trở lại",
        "homeIconTips2": "7 ngày trở lại",
        "homeIconTips4": "Thanh toán an toàn",
        "safe": "An toàn và không lo lắng",
        "safePayment": "Thanh toán an toàn",
        "homeDownloadtips4": "Tải xuống cho Android",
        "keep": "Duy trì",
        "saveQr": "Lưu mã QR",
        "payPal": "PayPal",
        "coinBlock": "Tiền tệ",
        "validatorRequire": "Các trường bắt buộc không được để trống",
        "edit": "Sửa bởi",
        "markDefaultAddress": "Đánh dấu làm địa chỉ giao hàng mặc định",
        "不能为空": "Nó không thể trống",
        "cancelOrder2": "Không thích, không muốn",
        "contactUs1": "Nếu bạn không muốn vay tiền từ bạn bè, vui lòng liên hệ với chúng tôi.",
        "不在交易时段": "Hết phiên giao dịch",
        "不在可提现时间内": "Hết thời gian rút tiền",
        "猜你喜欢": "Đoán bạn thích nó",
        "paramError": "Lỗi tham số",
        "参数错误": "Lỗi tham số",
        "参数异常，消息获取失败": "Lỗi tham số. Không nhận được tin nhắn",
        "Operate": "Hoạt động",
        "operationSuccess": "Hoạt động đã thành công",
        "操作成功": "Hoạt động đã thành công",
        "操作类型不能小于0": "Loại hoạt động không thể nhỏ hơn 0",
        "操作类型不是整数": "Loại hoạt động không phải là số nguyên",
        "操作类型为空": "Loại hoạt động trống",
        "view": "Xem",
        "Checkorder": "Xem đơn hàng",
        "logistics": "Xem hậu cần",
        "CheckDetails": "Xem chi tiết",
        "lowOpinion": "đánh giá xấu",
        "产品不存在": "Sản phẩm không tồn tại",
        "产品剩余数量不足": "Số lượng sản phẩm còn lại không đủ",
        "interest": "Tích lũy tiền lãi",
        "dealSuccess": "Thành công",
        "successTips": "Thành công",
        "beSeller": "Trở thành người bán",
        "homeBannertips1": "Trở thành người bán",
        "承兑商不存在": "Người chấp nhận không tồn tại",
        "orderCity": "Thành phố",
        "city": "Thành phố",
        "程序错误": "Lỗi chương trình",
        "持有币种不足": "Không đủ kinh phí",
        "recharge": "Tiền gửi",
        "rechargeSuccessful": "Gửi tiền thành công",
        "rechargeAddress": "Địa chỉ gửi tiền",
        "rechargeMethod": "Chế độ gửi tiền",
        "rechargeRecord": "Hồ sơ gửi tiền",
        "充值价值不得大于最大限额": "Số tiền gửi không thể vượt quá phạm vi giới hạn tối đa",
        "充值价值不得小于最小限额": "Số tiền gửi không được nhỏ hơn phạm vi giới hạn tối thiểu",
        "充值金额不能小于1": "Số tiền gửi không được nhỏ hơn 1 (bao gồm hai chữ số thập phân)",
        "充值链错误": "Lỗi liên kết gửi tiền",
        "rechargeNum": "Số tiền gửi",
        "充值数量不能小于等于0": "Số tiền gửi không được nhỏ hơn hoặc bằng 0",
        "rechargeTips": "Lưu ý gửi tiền: Vui lòng điền chính xác số tiền chuyển khoản. Nếu không, hệ thống có thể không vượt qua được phê duyệt và ảnh hưởng đến tiến trình sạc lại.",
        "dealing": "Đang tiến hành",
        "processing": "Đang tiến hành",
        "ship": "Thuyền",
        "creditText1": "Vay khởi nghiệp là để tránh rắc rối khi vay tiền",
        "businessloan": "Đơn xin vay vốn khởi nghiệp",
        "存在不同杠杆的持仓单": "Có nhiều lựa chọn đòn bẩy khác nhau",
        "cancelOrder7": "Có một vấn đề quan trọng",
        "存在重复的角色名称": "Tên vai trò trùng lặp",
        "大于最大采购数量": "Nhiều hơn số tiền mua tối đa",
        "代理层级错误": "Lỗi đại lý",
        "delivered": "Lô hàng đang chờ xử lý",
        "pendingPayment": "Trong khi chờ thanh toán",
        "待付款的订单无法放行": "Không thể giải phóng khoản thanh toán đang chờ xử lý",
        "comment": "Để được xem xét",
        "receipt": "Đã nhận được",
        "pending": "Trong khi chờ thanh toán",
        "loanHistory": "Hồ sơ cho vay",
        "rates": "Lãi suất vay",
        "term": "Điều khoản cho vay",
        "application": "Đơn xin vay tiền",
        "creditWorry": "Cho vay không lo lắng",
        "orderUnitprice": "Đơn giá",
        "当前地址格式错误": "Địa chỉ hiện tại có định dạng sai",
        "当前订单不为待付款状态，无法取消": "Lệnh hiện tại không ở trạng thái chờ xử lý. Nó không thể bị hủy bỏ.",
        "当前还需交易": "Giao dịch vẫn được yêu cầu",
        "currentRate": "Tỷ giá hối đoái hiện hành",
        "sure": "Tất nhiên rồi",
        "当日才可申购": "Chỉ có sẵn để mua trong cùng một ngày",
        "当日可提现次数不足": "Số lần rút tiền mặt không đủ mỗi ngày",
        "receivedAddress": "Địa chỉ người nhận",
        "orderAddress": "Địa chỉ",
        "登陆密码不符合设定": "Sai mật khẩu",
        "登陆密码长度不符合设定": "Sai mật khẩu",
        "login": "Đăng nhập",
        "loginIn": "Đăng nhập",
        "signIn": "Đăng nhập",
        "loginSuccess": "thành công",
        "登录过期，请重新登录": "Phiên đã hết hạn. Xin vui lòng đăng nhập lại",
        "LoginPassword": "Mật khẩu đăng nhập",
        "登录密码必须6-12位": "Mật khẩu phải có 6-12 ký tự",
        "登录密码不能为空": "Trường không thể trống",
        "登录失败": "Đăng nhập thất bại",
        "clickUpload": "Bấm để tải lên",
        "phoneNumber": "Số điện thoại",
        "电话号码已绑定": "Số điện thoại di động đã được liên kết",
        "电话号码已绑定其他用户": "Số điện thoại di động đã được liên kết với người dùng khác",
        "email": "E-mail",
        "shopCollection": "Thêm cửa hàng vào mục yêu thích",
        "订单": "Đặt hàng",
        "trackOrder": "Đặt hàng",
        "订单不存在": "Đơn hàng không tồn tại",
        "orderTrack": "Yêu cầu đặt hàng",
        "serialNumber": "Số thứ tự",
        "orderSummary": "Tổng số đơn đặt hàng",
        "cancelOrderSuccess": "Đơn hàng đã hủy",
        "订单退款成功": "Đơn hàng được hoàn tiền",
        "订单退款失败": "Đơn hàng không thành công để được hoàn tiền",
        "orderDetails": "Chi tiết đặt hàng",
        "orderInfo": "Thông tin đặt hàng",
        "订单已签收": "Đơn đặt hàng đã được nhận",
        "订单已取消": "Đơn đặt hàng đã bị hủy",
        "订单已取消，无法放行": "Đơn hàng đã bị hủy và không thể phát hành",
        "订单已取消，原因:超时自动取消订单": "Đơn hàng đã tự động bị hủy do hết thời gian chờ",
        "订单已取消，原因:手动发起取消订单": "Đơn đặt hàng đã bị hủy thủ công",
        "订单已完成": "Đơn hàng đã được hoàn thành",
        "订单已完成，无法放行": "Đơn đặt hàng đã được hoàn thành và không thể được phát hành",
        "moneyOrderStatus": "Tình trạng đặt hàng",
        "orderPrefix": "Tổng số đơn đặt hàng",
        "subscription": "Đặt mua",
        "aboutText2": "Hạn mức: 100.000-30.000.000, phương thức hoàn trả linh hoạt, lãi suất thấp, không mất phí trả trước, vay trực tuyến, không gọi điện xác minh, bảo mật thông tin, cho vay trong ngày.",
        "additional": "Hơn",
        "evaluateOrderSuccess": "Đánh giá thành công",
        "goodsShip": "Lô hàng",
        "发起退款申请": "Yêu cầu hoàn lại tiền",
        "send": "Gửi",
        "发现新版本，请升级到最新版本": "Đã tìm thấy phiên bản mới, vui lòng nâng cấp lên phiên bản mới nhất",
        "visitStore": "Ghé thăm cửa hàng",
        "collAccount": "Phương thức cho vay",
        "loanMethod": "Phương thức cho vay",
        "classification": "Loại",
        "服务器错误": "Lỗi máy chủ",
        "服务器错误(500)": "Lỗi máy chủ (500)",
        "servicePolicy": "Chính sách dịch vụ",
        "PaymentOrder": "Đề nghị thanh toán",
        "uploadTips": "Bằng chứng thanh toán (Tải lên ảnh chụp màn hình chi tiết thanh toán)",
        "copy": "Sao chép",
        "copySuccess": "Đã sao chép thành công",
        "该产品未上架": "Sản phẩm này không được liệt kê",
        "该产品已上市，无法购买": "Sản phẩm này đang có trên thị trường và không thể mua được",
        "该订单已取消": "Đơn hàng này đã bị hủy bỏ",
        "remindRepeat": "Lệnh này đã được nhắc nhở",
        "该广告剩余数量不足": "Số lượng quảng cáo còn lại không đủ",
        "该基金尚未开放购买": "Quỹ chưa được mở để mua",
        "该基金尚已封闭": "Quỹ đã bị đóng",
        "productAvailable": "Sản phẩm này đã được gỡ bỏ",
        "该邮箱已被订阅": "Email này đã được đăng ký",
        "notOpen": "Phương thức thanh toán này không áp dụng cho khu vực của bạn",
        "格式有误:充值金额不能小于1(包含俩位小数)": "Định dạng sai: Số tiền gửi không được nhỏ hơn 1 (bao gồm hai chữ số thập phân)",
        "userCenter": "Trung tâm cá nhân",
        "Item": "Mặt hàng)",
        "跟单倍数输入错误": "Lỗi nhiều đầu vào",
        "跟单参数输入错误": "Lỗi nhiều đầu vào",
        "more": "Hơn",
        "更新提醒": "Cập nhật lời nhắc",
        "工作地址不能为空": "Trường không thể trống",
        "homeBannertips2": "Tổng hoa hồng",
        "orderTotal": "Tổng cộng",
        "buyHistory": "Hồ sơ mua hàng",
        "购买矿机时间不得低于托管订单剩余时间": "Thời gian mua máy đào không được nhỏ hơn thời gian còn lại của đơn hàng hosting",
        "purchageHistory": "Lịch sử mua hàng",
        "addCartMessageFaild": "Sản phẩm đã có trong giỏ hàng của bạn",
        "fixedRate": "Lãi suất cố định",
        "aboutUs": "Về chúng tôi",
        "about": "Về chúng tôi",
        "followers": "Theo",
        "当前余额": "Số dư hiện tại",
        "followedSuccess": "thành công",
        "myFollowedShops": "Theo dõi cửa hàng",
        "广告不存在": "Quảng cáo không tồn tại",
        "广告已下架": "Quảng cáo đã bị xóa",
        "orderSpecification": "Sự chỉ rõ",
        "countryOf": "Quốc tịch",
        "areaCode": "Mã vùng quốc tế",
        "App下载(买家端)": "Tải xuống ứng dụng (Người mua)",
        "App下载(卖家端)": "Tải xuống ứng dụng (Người bán)",
        "orderNation": "Quốc gia",
        "nation": "Quốc gia",
        "repayment": "Trả nợ",
        "repay": "Phương thức hoàn trả",
        "reAmount": "Số tiền hoàn trả",
        "cycle": "Chu kỳ trả nợ",
        "loginTips": "Bạn chưa có số tài khoản?",
        "noAccount": "Bạn chưa có số tài khoản?",
        "NoProductSelected": "Chưa có sản phẩm nào được chọn",
        "shipping": "Đang chuyển hàng",
        "highOpinion": "Đánh giá tốt",
        "favorableRate": "Tỷ lệ đánh giá tốt",
        "myPraiseRate": "Tỷ lệ đánh giá tốt",
        "totalNum": "Tổng cộng",
        "partner": "Nhà cung cấp hợp tác",
        "partnersTit": "Đối tác - Nền tảng cho vay trực tuyến",
        "BackHome": "Quay lại trang chủ",
        "or": "hoặc",
        "freight": "Hàng hóa",
        "orderFreight": "Hàng hóa",
        "getCoupons": "Nhận thêm phiếu giảm giá",
        "基金剩余购买金额不足": "Số tiền mua còn lại của quỹ không đủ",
        "quickLoan": "Vay nhanh",
        "records": "Ghi",
        "proceed": "Tiếp tục",
        "storeSeachTips3": "Trang chủ",
        "家庭地址不能为空": "Trường không thể trống",
        "cancelOrder4": "Thương hiệu giả",
        "price": "Giá",
        "piece": "chiếc",
        "transactionPassword": "Mật khẩu giao dịch",
        "交易员不存在": "Người bán không tồn tại",
        "交易员不能跟随自己": "Người bán không thể theo kịp chính mình",
        "交易员跟随人数已满": "Số lượng người giao dịch theo dõi đã đầy",
        "交易员未开启带单": "Người bán chưa mở đơn hàng",
        "交易员无法跟随另一个交易员": "Người bán không thể theo dõi người bán khác",
        "角色被用户关联，不可删除": "Vai trò được liên kết bởi người dùng. Nó không thể bị xóa",
        "角色不存在": "Vai trò không tồn tại",
        "receiver": "Người nhận",
        "financial": "Giải quyết vấn đề tài chính của bạn",
        "successLoan": "Quá trình vay đã kết thúc thành công",
        "borrow": "Quá trình cho vay không thể kết thúc",
        "loanAgree": "Hiệp định vay vốn",
        "amount": "Số lượng",
        "金额不在购买区间": "Số tiền không nằm trong phạm vi mua",
        "validatorMaxNumber": "Số tiền vượt quá phạm vi giới hạn",
        "金额错误": "Lỗi số tiền",
        "validatorChineseAndEnglish": "Chỉ hỗ trợ tiếng Trung và tiếng Anh; nội dung đầu vào là 8-64 ký tự",
        "oldPassword": "Mật khẩu cũ",
        "旧密码不能为空": "Trường không thể trống",
        "旧密码不正确": "Mật mã cũ không chính xác",
        "可平仓合约张数不足": "Không đủ số lượng hợp đồng đóng vị thế",
        "service": "Dịch vụ khách hàng",
        "custService": "Dịch vụ khách hàng",
        "homeDownloadtips1": "Cửa hàng bán buôn thương mại điện tử xuyên biên giới",
        "矿机不存在": "Máy khai thác không tồn tại",
        "矿机未解锁，无法购买": "Máy khai thác bị khóa và không thể mua được.",
        "From": "Từ",
        "历史基金无法购买": "Không thể mua được tiền trong quá khứ",
        "historySearch": "Tìm kiếm lịch sử",
        "payment": "Thanh toán ngay",
        "buyNow": "Mua ngay",
        "homeBannerbtn": "Tham gia ngay",
        "evaluate": "Xem lại ngay bây giờ",
        "连续输入错误三次，请3分钟后再试": "Dữ liệu nhập không hợp lệ đã xảy ra ba lần liên tiếp. Vui lòng thử lại sau 3 phút",
        "contactUs": "Liên hệ chúng tôi",
        "twoPawword": "Mật khẩu không trùng khớp",
        "creditQuota": "Phạm vi giới hạn linh hoạt",
        "retailPrice": "Giá bán lẻ",
        "领取成功": "Đã nhận thành công",
        "pageviews": "Số lượt xem",
        "myPageviews": "Số lượt xem",
        "buyRules": "Quy tắc của người mua",
        "买入金额需要在区间内": "Số tiền mua phải nằm trong phạm vi",
        "卖方无法取消该订单": "Người bán không thể hủy đơn hàng",
        "cancelOrder3": "Người bán vận chuyển sai hàng hóa",
        "sellerRules": "Chính sách của người bán",
        "noDataFound": "Không tìm thấy dữ liệu nào",
        "没有找到用户": "Không tìm thấy người dùng",
        "dailyNewArrival": "Ưu đãi hàng ngày",
        "password": "Mật khẩu",
        "密码必须6-12位": "Mật khẩu phải có 6-12 ký tự",
        "密码不能为空": "Trường không thể trống",
        "密码不正确": "Sai mật khẩu",
        "wrongPassword": "Số lần thử vượt quá 3 lần. Vui lòng thử lại vào ngày mai",
        "validatorPassword": "Mật khẩu phải bao gồm 6-12 chữ cái và chữ số (chứa các ký tự đặc biệt)",
        "goodsFreeShipping": "Miễn phí",
        "orderName": "Tên",
        "defaultAddress": "Địa chỉ mặc định",
        "noCartTips": "Giỏ hàng của bạn đang trống. Bắt đầu mua sắm",
        "notLogin": "Bạn chưa đăng nhập.",
        "unSelectedProduct": "Bạn chưa chọn sản phẩm nào",
        "evaluationUploading": "Hình ảnh vẫn đang được tải lên. Vui lòng thử lại sau",
        "您当前可分配额度不足": "Giới hạn phân bổ hiện tại của bạn là không đủ",
        "yourEmail": "địa chỉ email của bạn",
        "您没有符合条件的收款方式": "Bạn không có phương thức thanh toán đủ điều kiện",
        "您已存在订单": "Bạn có một đơn đặt hàng",
        "您已购买过体验矿机,不得重复购买": "Bạn đã mua máy khai thác kinh nghiệm. Đừng mua nó nữa",
        "photoExample": "Ảnh Ví dụ",
        "homeDownloadtips2": "Thương hiệu đang giảm giá",
        "Evaluate": "Đánh giá",
        "evaluateOrder": "Đánh giá bằng hình ảnh",
        "evaluateInput": "Đánh giá bằng hình ảnh",
        "homeDownloadtips5": "Tải xuống cho Apple",
        "cancelOrder9": "Lý do khác",
        "businessPhone": "Lưu trữ số liên lạc",
        "businessEmail": "Tin nhắn hợp tác",
        "walletHistory": "Lịch sử ví",
        "亲属地址不能为空": "Trường không thể trống",
        "亲属电话不能为空": "Trường không thể trống",
        "亲属关系不能为空": "Trường không thể trống",
        "亲属姓名不能为空": "Trường không thể trống",
        "empty": "Trống",
        "evaluateOrderPlaceholder": "Vui lòng xem lại sản phẩm",
        "checkAgreement": "Hãy chấp nhận thỏa thuận!",
        "请检查网络连接": "Vui lòng kiểm tra kết nối mạng của bạn",
        "returnDetailTips": "Vui lòng cho nhận xét về sản phẩm",
        "switchLang": "Vui lòng chuyển sang ngôn ngữ khác để kiểm tra",
        "请切换其他语言后查看": "Vui lòng chuyển sang ngôn ngữ khác để kiểm tra",
        "请上传图片": "Vui lòng tải ảnh lên",
        "uploadPhoto": "Vui lòng tải ảnh lên",
        "请稍后再试": "Vui lòng thử lại sau",
        "请稍后重试": "Vui lòng thử lại sau",
        "pleaseSetLoginPassword": "Vui lòng nhập mật khẩu đăng nhập",
        "pleaseSetMobileNumber": "Vui lòng nhập số điện thoại",
        "pleaseEnterPhoneNumer": "Vui lòng nhập số điện thoại",
        "plaeseEnterInvitaionCode": "Vui lòng nhập mã mời",
        "pleaseEnterEmail": "Vui lòng nhập email",
        "enterTips": "Vui lòng nhập",
        "pleaseInput": "Vui lòng nhập",
        "validatorFourMoreNumber": "Vui lòng nhập nhiều hơn 4 ký tự",
        "pleaseValidPostCode": "Vui lòng nhập nhiều hơn 4 ký tự",
        "validatorSixNumber": "Vui lòng nhập 6 ký tự",
        "请输入充值币种": "Vui lòng nhập loại tiền gửi",
        "plaseEnterRechargeAddress": "Vui lòng nhập địa chỉ gửi tiền",
        "pleaseEnterAmount": "Vui lòng nhập số tiền gửi",
        "pleaseInputCorrectNumber": "Vui lòng nhập số lớn hơn 0",
        "pleaseEnterAddress": "Vui lòng nhập địa chỉ",
        "headerSearchTips": "Vui lòng nhập từ khóa để tìm kiếm",
        "pleaseEnterOldPassword": "Vui lòng nhập mật khẩu cũ",
        "pleaseEnterPassword": "Xin vui lòng nhập mật khẩu",
        "请输入内容": "Vui lòng nhập nội dung",
        "plaseeENterConfirmPassword": "Vui lòng nhập mật khẩu xác nhận",
        "pleaseEnterQuantity": "Vui lòng nhập số tiền",
        "请输入搜索关键字": "Vui lòng nhập từ khóa để tìm kiếm",
        "withdrawInputTips": "Vui lòng nhập địa chỉ rút tiền",
        "plaseeEnterNewPassword": "Vui lòng nhập mật khẩu mới",
        "yourName": "Vui lòng nhập tên",
        "pleaseEnterAccount": "Vui lòng nhập số tài khoản",
        "请输入正确的货币数量": "Vui lòng nhập đúng số tiền",
        "请输入正确的金额": "Vui lòng nhập đúng số tiền",
        "validatorPhone": "Vui lòng nhập đúng số điện thoại di động",
        "pleaseValidPhone": "Vui lòng nhập đúng số điện thoại di động",
        "请输入正确的数量": "Vui lòng nhập đúng số tiền",
        "inpuEmailErro": "Vui lòng nhập đúng địa chỉ email",
        "pleaseValidEmail": "Vui lòng nhập đúng địa chỉ email",
        "validatorEmail": "Vui lòng nhập email đúng định dạng",
        "请输入正确的质押金额": "Vui lòng nhập đúng số tiền cam kết",
        "请输入正确的质押天数": "Vui lòng nhập đúng số ngày để cam kết",
        "pleaseCorrectAddress": "Vui lòng nhập đúng địa chỉ rút tiền",
        "请填写正确的电话号码": "Vui lòng nhập đúng số điện thoại di động",
        "请填写正确的验证码": "Vui lòng nhập mã xác minh chính xác",
        "mailboxCheck": "Vui lòng nhập đúng địa chỉ email",
        "请填写正确的邮箱地址": "Vui lòng nhập đúng địa chỉ email",
        "请先绑定谷歌验证器": "Vui lòng liên kết Google Authenticator trước",
        "请先添加收款方式": "Vui lòng thêm phương thức thanh toán trước",
        "请先通过高级认证": "Vui lòng vượt qua chứng chỉ nâng cao trước",
        "cancelOrderTitle": "Vui lòng chọn lý do hủy đơn hàng",
        "selectCountry": "Vui lòng chọn quốc tịch",
        "请选择买卖方式": "Vui lòng chọn phương thức thanh toán",
        "selectPeriod": "Vui lòng chọn một khoảng thời gian",
        "returnOrderTitle": "Vui lòng chọn lý do trả hàng",
        "请选择正确的币种": "Vui lòng chọn đúng loại tiền tệ",
        "请重新登录": "Xin vui lòng đăng nhập lại",
        "blockchainNetwork": "Mạng chuỗi khối",
        "渠道未开通": "Kênh chưa được mở",
        "Cancel": "Hủy bỏ",
        "取消": "Hủy bỏ",
        "cancelSuccess": "Đã hủy thành công",
        "cancelOrder": "Hủy đơn hàng",
        "cancel": "Hủy đơn hàng",
        "CancelOrder": "Hủy đơn hàng",
        "myUnfollow": "Hủy theo dõi",
        "cancelReason": "Lý do hủy",
        "all": "Xem tất cả",
        "AllProducts": "Tất cả sản phẩm",
        "btnSure": "Xác nhận",
        "确认": "Xác minh",
        "entRepay": "Xác nhận thanh toán",
        "confirmPayPaw": "Xác nhận mật khẩu giao dịch",
        "confirmPassword": "Xác nhận mật khẩu",
        "delAllHistoryRecord": "Bạn có chắc chắn muốn xóa tất cả các bản ghi lịch sử không?",
        "confirm": "Xác nhận",
        "date": "Ngày",
        "scanAndDown": "Quét mã QR để tải APP",
        "homeDownloadtips6": "Quét mã QR để tải APP",
        "delete": "Xóa bỏ",
        "sellerPanelLogin": "Đăng nhập người bán",
        "merchantSettled": "quan hệ đối tác",
        "sellerZone": "Khu thương mại",
        "商家已确认，已进入备货状态": "Người bán đã được xác nhận và bắt đầu quá trình nhập kho",
        "commodity": "Sản phẩm",
        "orderCommodity": "Sản phẩm",
        "commodityCollection": "Bộ sưu tập sản phẩm",
        "productDescription": "Mô tả Sản phẩm",
        "myCommodityCollection": "Sản phẩm yêu thích",
        "goodsNumber": "Số lượng sản phẩm",
        "goodsShipTips": "Sau khi đặt hàng, nó sẽ được vận chuyển trong vòng 24 giờ. Thời gian vận chuyển phụ thuộc vào hậu cần và có thể kéo dài. Vui lòng chú ý đến thông tin hậu cần hoặc liên hệ với Dịch vụ khách hàng",
        "productInfo": "Thông tin sản phẩm",
        "uploadSuccess": "Tải lên thành công",
        "uploadError": "Không tải lên được, vui lòng thử lại",
        "uploading": "Đang tải lên...",
        "upNew": "Sản phẩm mới",
        "previous": "Bước trước",
        "prevPage": "Trang trước",
        "cancelOrder5": "Giao hàng ít, giao hàng bị thiếu",
        "desc": "Đặt làm địa chỉ mặc định",
        "setAsTheDefaultAddress": "Đặt làm địa chỉ mặc định",
        "setUp": "Cài đặt",
        "setSuccess": "Thiết lập thành công",
        "setUpPayPaw": "Đặt mật khẩu giao dịch",
        "setPassword": "Đặt mật khẩu",
        "申购数量错误": "Số tiền mua sai",
        "申请成功": "thành công",
        "applyLoan": "Đăng ký vay",
        "applicationAmount": "Số tiền yêu cầu",
        "noSmaller": "Số tiền yêu cầu không được ít hơn",
        "nomax": "Số tiền yêu cầu không thể vượt quá",
        "applicant": "Người xin việc",
        "applicantDate": "Ngày nộp hồ sơ",
        "return": "Yêu cầu hoàn tiền sản phẩm",
        "applicantIn": "Ứng dụng đang được tiến hành",
        "身份证已实名过!": "Thẻ ID đã được xác minh!",
        "审核已通过": "Tán thành",
        "审核中": "Đang xem xét",
        "state": "Tỉnh/Tiểu bang/Khu vực",
        "dealFail": "Thất bại",
        "fail": "Thất bại",
        "orderTime": "Thời gian",
        "time": "Thời gian",
        "ActualLedger": "Thực tế nhận được",
        "actualAccount": "Tài khoản thực tế",
        "实名认证未通过，无法进行高级认证": "Quá trình xác thực đã thất bại; không thể thực hiện xác thực nâng cao",
        "confirmReceiveGoods": "Xác nhận đã nhận sản phẩm",
        "collect": "Yêu thích",
        "collectionSuccess": "Đã thêm vào mục yêu thích thành công",
        "wishlist": "Sản phẩm yêu thích",
        "cancelOrder6": "Nhận được sản phẩm bị hư hỏng",
        "desc5": "Địa chỉ giao hàng sai? Liên hệ",
        "consigneeName": "Tên người nhận",
        "shippingAddress": "Địa chỉ ngưởi nhận",
        "pleaseAddShippingAddress": "Vui lòng thêm địa chỉ giao hàng trước",
        "收款方输入错误": "Lỗi đầu vào",
        "购物车还没有商品": "Giỏ hàng của bạn đang trống",
        "去购物": "Bắt đầu mua sắm",
        "mobile": "Số di động",
        "mobilePhone": "Số điện thoại",
        "handleFee": "Phi dịch vụ",
        "handlingFee": "Phi dịch vụ",
        "home": "Trang chủ",
        "授权状态未成功": "Trạng thái ủy quyền không thành công",
        "pleaseSetAreaCode": "Nhập tên quốc gia và mã vùng để tìm kiếm",
        "searchCountry": "Nhập tên quốc gia và mã vùng để tìm kiếm",
        "desc3": "Nhập mật khẩu giao dịch",
        "desc4": "Nhập mật khẩu giao dịch của bạn",
        "赎回状态异常": "Trạng thái quy đổi bất thường",
        "quantity": "Số lượng",
        "orderAmount": "Số lượng",
        "orderQuantity": "Số lượng",
        "inputNum": "số",
        "orderTax": "Thuế",
        "orderFee": "Thuế",
        "tax": "Thuế",
        "delivery": "Giao hàng & thu tiền",
        "storeSeach": "Tìm kiếm sản phẩm trong cửa hàng này",
        "search": "Tìm kiếm",
        "所选汇率不存在": "Tỷ giá hối đoái đã chọn không tồn tại",
        "allProduct": "Tất cả sản phẩm",
        "提币数量不能小于等于0": "Số tiền rút không thể nhỏ hơn hoặc bằng 0",
        "creditText2": "Cung cấp dịch vụ cho vay khởi nghiệp và quay vòng vốn",
        "returnOrderSuccess": "gửi thành công",
        "Submitareview": "Gửi đánh giá",
        "submitApplica": "Nộp đơn",
        "提交失败": "Gửi không thành công",
        "提交失败，当前有未处理订单": "Gửi không thành công. Hiện đang có đơn đặt hàng mở",
        "hint": "Mẹo",
        "提示": "Mẹo",
        "withdraw": "Rút",
        "提现不得大于限额": "Rút tiền mặt không được lớn hơn hạn mức",
        "提现不得小于限额": "Rút tiền mặt không được ít hơn hạn mức",
        "withdrawSuccess": "Đơn đặt hàng được gửi thành công",
        "withdrawAddress": "Địa chỉ rút tiền",
        "withdrawRecord": "Hồ sơ rút tiền",
        "withdrawNum": "Số lượng rút",
        "tipsRemindsSuccess": "Lời nhắc đã thành công",
        "remindSuccess": "Lời nhắc đã thành công",
        "RemindShip": "Nhắc nhở vận chuyển",
        "remind": "Nhắc nhở lô hàng",
        "remindTitle": "Nhắc nhở lô hàng",
        "tipsRemindsText": "Sau khi vận chuyển sản phẩm, người bán sẽ nhận được thông báo",
        "remindContent": "Sau khi vận chuyển sản phẩm, người bán sẽ chỉ nhận được thông báo một lần",
        "tipsRemindsMerchant": "Nhắc nhở người bán",
        "days": "(các) ngày",
        "addCartMessage": "Đã thêm vào giỏ hàng của bạn thành công",
        "addAddress": "thêm địa chỉ mới",
        "addAddressOrModifyAddress": "Thêm địa chỉ mới/Thay đổi địa chỉ",
        "addCart": "Thêm vào giỏ hàng",
        "图片不得大于10M": "Kích thước tệp cho hình ảnh không được lớn hơn 10M",
        "图片不得大于2M": "Kích thước tệp cho hình ảnh không được lớn hơn 2M",
        "图片大小不能超过2M！": "Kích thước tệp cho một hình ảnh không được vượt quá 2M!",
        "图片上传失败": "Không thể tải hình ảnh lên",
        "recommendclass": "Cửa hàng theo thể loại",
        "recommend": "Gợi ý",
        "recommendedProducts": "Mặt hàng phổ biến",
        "recommendedStore": "Cửa hàng nổi tiếng",
        "推荐码不正确": "Mã đề xuất sai",
        "推荐人无权限推荐": "Không có thẩm quyền đề nghị",
        "推荐商品": "Mặt hàng phổ biến",
        "logout": "Đăng xuất",
        "returnsAndEx": "Trả lại và trao đổi",
        "returnAmount": "Số tiền hoàn trả",
        "returnRemark": "Hướng dẫn trả lại",
        "returnPolicy": "Chính sách hoàn trả",
        "Refund": "Đền bù",
        "refund": "Hoàn tiền/sau bán hàng",
        "退款成功": "Hoàn tiền thành công",
        "refundSuccessfully": "Hoàn tiền thành công",
        "refundSuccess": "Hoàn tiền thành công",
        "returnReason": "Lý do hoàn tiền",
        "returnApply": "Yêu cầu hoàn tiền",
        "退款失败": "Hoàn tiền không thành công",
        "refundFail": "Hoàn tiền không thành công",
        "refundInstructions": "Hướng dẫn hoàn tiền",
        "refunding": "Đang hoàn tiền",
        "mastercard": "MasterCard",
        "EsShop": "Cửa hàng trực tuyến",
        "ForgotPassword": "Quên mật khẩu?",
        "委托数量(张)必填": "Số lượng ủy thác (chiếc.) là bắt buộc",
        "委托数量(张)不能小于等于0": "Số lượng ủy thác (chiếc.) không được nhỏ hơn hoặc bằng 0",
        "foryourmoney": "Vay tiền trực tuyến là một lựa chọn thuận tiện và nhanh chóng để giải quyết vấn đề tài chính của bạn. Bạn sẽ không cảm thấy xấu hổ như khi vay tiền bạn bè. Đội ngũ chuyên nghiệp của chúng tôi sẽ giúp bạn thực hiện quy trình và giải tỏa những nghi ngờ của bạn bất cứ lúc nào. Chúng tôi mong muốn cung cấp cho khách hàng mọi khoản vay một cách nhanh chóng, minh bạch và an toàn.",
        "storeSeachTips1": "Tìm cho bạn",
        "未绑定谷歌验证器": "Google Authenticator chưa được liên kết",
        "未绑定手机号": "Số điện thoại di động chưa được thêm vào",
        "未绑定邮箱": "Email chưa được thêm vào",
        "未发现授权记录": "Hồ sơ ủy quyền chưa được tìm thấy",
        "notQua": "Không đáp ứng được yêu cầu",
        "ShippingAddressNotSet": "Địa chỉ giao hàng chưa được thiết lập",
        "未实名认证，是否认证？": "Không được xác thực bằng tên thật. Xác thực?",
        "cancelOrder1": "Sản phẩm chưa được nhận",
        "未授权访问": "Truy cập trái phép",
        "noRefund": "Không được hoàn tiền",
        "未找到符合条件的匹配订单": "Không tìm thấy đơn hàng phù hợp",
        "未找到匹配的收益记录": "Không tìm thấy bản ghi doanh thu phù hợp",
        "mine": "Của tôi",
        "myloan": "Khoản vay của tôi",
        "myOrder": "Đơn hàng của tôi",
        "myCart": "Giỏ hàng của tôi",
        "我的购物车": "Giỏ hàng của tôi",
        "myPurse": "Ví của tôi",
        "myAccount": "Tài khoản của tôi",
        "aboutText1": "Chúng tôi cung cấp dịch vụ cho vay dựa trên triết lý kinh doanh Khách hàng là trên hết, nhằm giải quyết vấn đề tài chính vốn của khách hàng. Kể từ khi công ty được thành lập, chúng tôi đã giúp nhiều khách hàng giải quyết vấn đề xoay vòng vốn của họ.",
        "readAndAgree": "Tôi đã đọc và chấp nhận",
        "safeInfo": "Không yêu cầu thế chấp, không đặt cọc và không gọi lại. Đó là một vấn đề riêng tư.",
        "无权限": "không có quyền",
        "无效的UID": "UID không hợp lệ",
        "item": "Mục",
        "系统参数错误": "Lỗi tham số hệ thống",
        "系统存在相同[系统登录名]！": "Một người dùng khác đã tồn tại trong hệ thống có cùng tên đăng nhập",
        "系统错误，请稍后重试": "Lỗi hệ thống. Vui lòng thử lại sau",
        "系统发货成功": "thành công",
        "系统默认好评": "Đánh giá tốt theo mặc định",
        "defaultRate": "Đánh giá tốt theo mặc định",
        "checkout": "Đặt hàng",
        "下单不能小于最小金额限制": "Số tiền đặt lệnh không được nhỏ hơn giới hạn tối thiểu",
        "下单成功，等待付款": "Đơn hàng đã được đặt thành công và chúng tôi đang chờ thanh toán",
        "下单成功，付款成功": "Thanh toán thành công",
        "buyTips": "Sau khi đặt hàng, nó sẽ được vận chuyển trong vòng 24 giờ. Thời gian vận chuyển phụ thuộc vào hậu cần và có thể kéo dài. Vui lòng chú ý đến thông tin hậu cần hoặc liên hệ với bộ phận Dịch vụ khách hàng.",
        "nextPage": "Trang tiếp theo",
        "stateMent": "Tuyên bố về chế độ nô lệ hiện đại",
        "storeSeachTips2": "Đã tìm thấy cửa hàng liên quan",
        "address": "Địa chỉ chi tiết",
        "items": "Mục",
        "browse": "Tổng doanh thu",
        "sold": "Đã bán",
        "sales": "Tổng doanh thu",
        "校验IP不合法": "IP xác minh không hợp lệ",
        "new": "Mới",
        "newPassword": "Mật khẩu mới",
        "新密码不能为空": "Trường không thể trống",
        "新密码不一致": "Mật khẩu không khớp",
        "新密码确认不能为空": "Trường không thể trống",
        "news": "Tin tức",
        "addNewAddress": "thêm địa chỉ mới",
        "creditTit": "Dịch vụ cho vay tín dụng",
        "Information": "Thông tin",
        "行情获取异常，稍后再试": "Báo giá không bình thường, vui lòng thử lại sau",
        "modifyAddress": "Thay đổi địa chỉ",
        "handlingfee": "Cần có phí dịch vụ",
        "Opt": "Lựa chọn",
        "selectDeliveryAddress": "Chọn địa chỉ giao hàng",
        "验证类型不能为空": "Trường không thể trống",
        "验证码不能为空": "Trường không thể trống",
        "验证码不正确": "Mã xác minh không chính xác",
        "验证码错误": "Lỗi mã xác minh",
        "vcodeFail": "Mã xác nhận thất bại. Vui lòng thử lại",
        "vcodePass": "Đã xác minh!",
        "invitationCode": "Mã mời",
        "页码不能小于等于0": "Số trang không được nhỏ hơn hoặc bằng 0",
        "页码不是整数": "Số trang không phải là số nguyên",
        "dashboard": "bảng điều khiển",
        "loaned": "Đã cho mượn",
        "loanDays": "Khoảng thời gian",
        "已发货，正在运输中": "Đã vận chuyển, đang vận chuyển",
        "followed": "Đã theo dõi",
        "repaid": "Trả nợ",
        "已领取": "Đã nhận",
        "rated": "Đã đánh giá",
        "cancelled": "Đã hủy",
        "confirmed": "Đã xác nhận",
        "harvested": "Đã nhận",
        "mySold": "Đã bán",
        "overdue": "Quá hạn",
        "privacyPolicy": "Chính sách bảo mật",
        "用户不存在": "Người dùng không tồn tại",
        "用户名必须由数字和英文字母组成": "Tên người dùng phải bao gồm số và chữ cái",
        "用户名不存在": "Người dùng không tồn tại",
        "用户名不符合设定": "Tên người dùng không khớp",
        "用户名不能为空": "Trường không thể trống",
        "用户名参数为空": "Trường không thể trống",
        "用户名重复": "Sao chép tên người dùng",
        "userEvaluation": "Đánh giá của người dùng",
        "用户剩余数量不足": "Không đủ số lượng người dùng",
        "用户已跟随交易员": "Người dùng đang theo dõi cửa hàng",
        "user_Center": "Trung tâm người dùng",
        "userReg": "Đăng ký người dùng",
        "postCode": "Mã bưu điện",
        "orderEmail": "E-mail",
        "邮箱已绑定": "Email đã được ràng buộc",
        "邮箱已绑定其他用户": "Email đã được liên kết với người dùng khác",
        "orderPostCode": "Mã bưu điện",
        "hasImage": "Với hình ảnh",
        "Balance": "Sự cân bằng",
        "balance": "Số dư (USDT)",
        "余额不足": "Thiếu cân bằng",
        "balanceNot": "Số dư không đủ, vui lòng gửi tiền",
        "cancelOrder8": "Đàm phán hoàn lại tiền với người bán",
        "expectedArrival": "Khách hàng mong đợi",
        "esRepayment": "Dự kiến trả nợ",
        "estirepay": "Dự kiến trả nợ",
        "originPrice": "Giá gốc",
        "deliveryFee": "vận chuyển hàng hóa",
        "goodsFreight": "vận chuyển hàng hóa",
        "shippingDiscounts": "Giảm giá cước vận chuyển",
        "homeIconTips3": "Giảm giá cước vận chuyển",
        "desc6": "Nhập lại mật khẩu giao dịch của bạn",
        "rebuy": "Một đơn hàng nữa",
        "onlineService": "Dịch vụ trực tuyến",
        "customeService": "Dịch vụ khách hàng trực tuyến",
        "helpLine": "Dịch vụ khách hàng trực tuyến",
        "onlineApplin": "Đăng ký trực tuyến",
        "暂无店铺": "Không tìm thấy cửa hàng",
        "noComments": "Chưa có bình luận nào",
        "noData": "Không tìm thấy dữ liệu nào",
        "帐户异常需要进行C3认证，请联系在线客服。": "Ngoại lệ tài khoản yêu cầu xác thực C3. Vui lòng liên hệ với Dịch vụ khách hàng trực tuyến.",
        "account": "Tài khoản",
        "accountBalance": "Số dư tài khoản",
        "accountB": "Số dư tài khoản",
        "accountReview": "tổng quan vê tai khoản",
        "Recruitment": "Nghề nghiệp",
        "找不到用户": "Người dùng chưa được tìm thấy",
        "searchTips": "Tìm kiếm thương hiệu/sản phẩm/nhà cung cấp",
        "discount": "Giảm giá",
        "homeDownloadtips3": "Giảm giá không ngừng",
        "discounted": "Giảm giá",
        "actualName": "Họ và tên",
        "passPortImg": "Số CMND/Hộ chiếu",
        "uploadId": "Tải ảnh CMND/Hộ chiếu lên",
        "Payment": "Sự chi trả",
        "pay": "Sự chi trả",
        "paymentSuccessful": "Thanh toán thành công",
        "paymentPending": "Đang chờ thanh toán",
        "paymentPendingDesc": "Thanh toán của bạn đang được xử lý, vui lòng kiểm tra trạng thái đơn hàng sau",
        "paymentMethod": "Phương thức thanh toán",
        "paymethods": "Phương thức thanh toán",
        "payCertificate": "Chứng chỉ thanh toán",
        "直线关系，不能修改推荐": "Quan hệ đường thẳng, khuyến nghị không thể sửa đổi",
        "tipsRemindsCount": "Chỉ có thể được nhắc nhở một lần",
        "committed": "Chúng tôi tận tâm cung cấp dịch vụ cho vay cho các doanh nhân",
        "mediumOpinion": "Đánh giá trung bình",
        "sort": "Kiểu",
        "重复提交": "Gửi lại",
        "Reapply": "Đăng ký lại",
        "register": "Đăng ký",
        "signUp": "Đăng ký",
        "registerSuccess": "Đăng ký thành công",
        "转账币种不能为空": "Trường không thể trống",
        "转账数量不能小于等于0": "Số tiền chuyển không thể nhỏ hơn hoặc bằng 0",
        "orderStatus": "Trạng thái",
        "orderState": "Trạng thái",
        "状态不能小于0": "Trạng thái không thể nhỏ hơn 0",
        "状态不是整数": "Trạng thái không phải là số nguyên",
        "资金密码必须6-12位": "Mật khẩu quỹ phải có 6-12 ký tự",
        "资金密码不符合设定": "Mật khẩu quỹ không khớp",
        "资金密码不能为空": "Trường không thể trống",
        "资金密码错误": "Lỗi mật khẩu quỹ",
        "资金密码长度不符合设定": "Độ dài của mật khẩu không khớp với cài đặt",
        "complex": "Tổng hợp",
        "totalOf": "Tổng cộng",
        "totalPrice": "Tổng giá",
        "homeBannertips3": "Tối đa.",
        "creditReview": "Vượt qua cuộc kiểm toán sớm nhất trong một giờ. Nếu việc xem xét được thông qua, khoản vay sẽ được giải ngân ngay lập tức.",
        "yesterday": "Hôm qua",
        "binance": "Binance",
        "huobi": "Huobi",
        "validatorIpRule": "Địa chỉ IP không chính xác",
        "metaMask": "MetaMask",
        "footTip": "{name} Limited 2024. Mọi quyền được bảo lưu.",
        "footTips": "{name} Limited được Cơ quan quản lý tài chính ủy quyền và quản lý với tư cách là nhà môi giới tín dụng (713206) và giao dịch độc quyền với người cho vay Home Retail Group CardServices Limited với tư cách là MetaShop Financial Services. {name} Dịch vụ tài chính được Cơ quan quản lý tài chính ủy quyền và quản lý để cung cấp tín dụng (716148). Home Retail GroupCard Services Limited được đăng ký tại Vương quốc Anh (04007072) tại Avebury, 489-499 Avebury Boulevard, Milton Keynes, Vương quốc Anh. MK9 2NW.",
        "footdec": "Người dùng trang web toàn cầu của {name} đến từ {num} quốc gia trên thế giới và sử dụng {coin} để thanh toán. {coin} là giao dịch không biên giới cho phép giao dịch ngay lập tức với chi phí thấp trên toàn thế giới mà không phải chờ đợi và tính phí quốc tế.",
        "okx": "được thôi",
        "备注": "Bình luận",
        "UID不能为空": "UID không thể trống",
        "滑动验证": "Kéo thanh trượt để hoàn thành câu đố",
        "头像选择": "Chọn một bức ảnh",
        "修改头像": "Thay đổi",
        "银行卡": "Thẻ ngân hàng",
        "客户端下载": "Tải về",
        "提现方式": 
            "Cách tiến hành",
        "平台人工发起退款": "Hoàn tiền do nền tảng thực hiện",
        "最多上传9张图片": "Tải lên tối đa 9 ảnh",
        "账号注销": "Hủy tài khoản",
        "确定注销": "Xác nhận hủy",
        "您的账号": "Tài khoản của bạn",
        "为什么要离开": "Tại sao bạn muốn rời đi",
        "您还有余额,不能注销账号": "Bạn vẫn còn số dư, bạn không thể hủy tài khoản của mình được!",
        "请输入注销理由": "Vui lòng nhập lý do hủy",
        "您确认要注销吗?": "Bạn có chắc là muốn hủy bỏ?",
        "我再考虑下": "tôi sẽ nghĩ về nó",
        "同意注销": "Đồng ý hủy",
        "注销成功": "Hủy thành công",
        "请选择": "Vui lòng chọn",
        "提款地址绑定": "Ràng buộc địa chỉ rút tiền",
        "绑定成功": "Ràng buộc thành công",
        "仅能绑定一个收款地址!": "Chỉ có một địa chỉ có thể bị ràng buộc!",
        "加值": "Thêm giá trị",
        "提领": "Rút tiền",
        "联系商家": "Liên hệ với người bán",
        "最多包含10位小数": "Lên đến 10 chữ số thập phân",
        "加密货币": "tiền điện tử",
        "企业电话":
            "Số điện thoại công ty",
        "参数缺失": "Thiếu thông số",
        "充值数量必填": "Trường không thể trống",
        "充值币种": "Tiền gửi",
        "职业机会":
            "Cơ hội công việc",
        "充值金额": "Số tiền gửi",
        "充值金额不得小于": "Số tiền gửi không được nhỏ hơn",
        "长时间未付款，系统自动取消订单": "Thanh toán không thành công trong thời gian dài, đơn hàng sẽ bị hủy tự động",
        "充值金额不得大于": "Số tiền gửi không thể lớn hơn",
        "请先选择币种": "Vui lòng chọn loại tiền tệ trước tiên",
        "开户行": "Ngân hàng",
        "请输入开户行名称": "Vui lòng nhập tên ngân hàng",
        "银行卡号": "Số thẻ ngân hàng",
        "请输入银行卡号": "Vui lòng nhập số thẻ ngân hàng",
        "点击去支付": "Bấm để thanh toán",
        "企业证明": "Chứng nhận doanh nghiệp",
        "footTipTikTok": "Trung tâm mua sắm CoveBuy ©️2024 Bản quyền",
        "TikTokFoot": "CoveBuy Mall là nền tảng xã hội video ngắn toàn cầu CoveBuy và công ty thương mại bán buôn lớn nhất châu Á Alibaba, được thành lập với sự hợp tác. Đây là nền tảng thương mại điện tử toàn cầu và có ba kho thông minh tự vận hành trên thế giới, đặt tại Toronto, Canada, Los Angeles và Chiba, Nhật Bản. Các sản phẩm được bán trong ứng dụng bao gồm các sản phẩm phổ biến từ Nhật Bản, Hàn Quốc, Trung Quốc và các nước châu Á khác. Hiện tại, tổng số đã vượt quá 50.000 và tiếp tục tăng nhanh.",
        "cancelInfo": "Cảnh báo! Hãy cẩn thận để hủy tài khoản. Nếu bạn không sử dụng tài khoản nữa, bạn có thể nhấp vào [Đồng ý hủy bỏ]. Bạn có thể không đăng ký được trong vòng vài ngày sau khi hủy.",
        "betaBannerText": "Trang web đang trong giai đoạn thử nghiệm công khai, vui lòng không đặt hàng"
}